var _path, _rect, _rect2, _rect3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayout15 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 90 160"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#666",
  d: "M0 0h90v160H0z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 6,
  x: 29,
  y: 6,
  fill: "#CCC",
  rx: 3
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 6,
  x: 68,
  y: 6,
  fill: "#CCC",
  rx: 3
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 6,
  x: 6,
  y: 6,
  fill: "#CCC",
  rx: 3
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M6 18h78v3.65H6zM6 23.65h78v3.65H6zM6 29.3h78v3.65H6zM6 34.95h78v3.65H6zM6 40.6h78v3.65H6zM6 46.25h78v3.65H6zM6 51.9h78v3.65H6zM6 57.55h78v3.65H6zM6 63.2h78v3.65H6zM6 68.85h78v3.65H6zM6 74.5h78v3.65H6zM6 80.15h78v3.65H6zM6 86h78v3.65H6zM6 91.65h78v3.65H6zM6 97.3h78v3.65H6zM6 102.95h78v3.65H6zM6 108.6h78v3.65H6zM6 114.25h78v3.65H6zM6 119.9h78v3.65H6zM6 125.55h78v3.65H6zM6 131.2h78v3.65H6zM6 136.85h78v3.65H6zM6 142.5h78v3.65H6zM6 148.15h78v3.65H6z"
})));
export { SvgLayout15 as ReactComponent };